module.exports = __webpack_public_path__ + "img/news_hyperlocation_map.782df762.png";